import React, { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../utils/Hooks";
import { LoggedInView } from "../common/LoggedInView";
import {setContacts} from "../../store/reducers/ContactsSlice";
import {useNavigate} from "react-router-dom";

interface SendSMSStep2Props {}

export const SendSMSStep2: React.FC<SendSMSStep2Props> = () => {

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const contactsState = useAppSelector((state) => state.contacts);

    const [checkedContacts, setCheckedContacts] = useState<number[]>([]);

    useEffect(() => {
        const initialCheckedContacts = contactsState.contacts.map((contact) => contact.id);
        setCheckedContacts(initialCheckedContacts);
    }, [contactsState.contacts]);

    const handleCheckboxChange = (contactId: number) => {
        if (checkedContacts.includes(contactId)) {
            setCheckedContacts(checkedContacts.filter((id) => id !== contactId));
        } else {
            setCheckedContacts([...checkedContacts, contactId]);
        }
    };

    const handleSelectAllChange = () => {
        if (checkedContacts.length === contactsState.contacts.length) {
            setCheckedContacts([]);
        } else {
            const allContactIds = contactsState.contacts.map((contact) => contact.id);
            setCheckedContacts(allContactIds);
        }
    };

    const next = () => {

        const filteredContacts = contactsState.contacts.filter(contact => {
            return checkedContacts.includes(contact.id);
        });

        dispatch(setContacts(filteredContacts));

        navigate('/send-sms/3')

    };

    return (
        <LoggedInView fullWidth={false}>
            <h1>Saada E-mail</h1>
            <h2>
                <span>Vali hankijad, kellele kiri saata</span>
            </h2>
            <table className="form">
                <tr>
                    <th style={{ textAlign: "left" }}>
                        <input
                            type="checkbox"
                            id="toggleAllCheckboxes"
                            checked={checkedContacts.length === contactsState.contacts.length}
                            onChange={handleSelectAllChange}
                        />
                        <label>Kõik</label>
                    </th>
                </tr>
                {contactsState?.contacts?.map((contact, key) => (
                    <>
                        <tr key={key}>
                            <th style={{ textAlign: "left" }}>
                                {(key + 1)}
                                {contact.client && <label htmlFor="vendor"> {contact.client.name}</label>}
                                {contact.vendor && <label htmlFor="vendor"> {contact.vendor.name}</label>}
                            </th>
                            <td></td>
                            {contact.client && <td style={{ textAlign: "left" }}>{contact.client.comment}</td>}
                            {contact.vendor && <label htmlFor="vendor"> {contact.vendor.comment}</label>}
                        </tr>
                        <tr>
                            <th style={{ textAlign: "left" }}></th>
                            <td>
                                <input
                                    className="vendorCheckbox"
                                    type="checkbox"
                                    name="vendors[]"
                                    id={`vendor_${contact.id}`}
                                    value={contact.id}
                                    checked={checkedContacts.includes(contact.id)}
                                    onChange={() => handleCheckboxChange(contact.id)}
                                />
                                {contact.name} ({contact.phone})
                            </td>
                            <td style={{ textAlign: "left" }} id={`comment_${contact.id}`}>
                                {contact.comment}
                            </td>
                        </tr>
                    </>
                ))}
                <tr>
                    <th></th>
                    <td>
                        <div className="action clear">
                            <p>
                                <button onClick={next}>
                                    <span>
                                        <strong>Edasi</strong>
                                    </span>
                                </button>
                            </p>
                        </div>
                    </td>
                </tr>
            </table>
        </LoggedInView>
    );
};